import * as React from 'react'
import cn from 'classnames'
import { getGridGutter, span, theme } from '../../styles/theme'
import { createUseStyles } from '../../helpers/createStyles'
import Section from '../Section'
import PostTile from './ProductRelatedPosts/PostTile'
import Slider from '../Slider'
import useBreakpoint from '../../hooks/useBreakpoint'
import { values as breakpoints } from '../../styles/breakpoints'
import useScrollTrigger from '../../hooks/useScrollTrigger'

const sliderOptions = { contain: true, cellAlign: 'left' }

const hasLandscapeImage = post => {
  try {
    return post.featuredImage.asset.metadata.dimensions.aspectRatio >= 1
  } catch (e) {
    return true
  }
}

const JournalRelatedArticles = ({
  data: { manualMode, chosenArticles = [], relatedArticles = [], title }
}) => {
  const { width } = useBreakpoint()
  const styles = useStyles()
  const posts = React.useMemo(
    () =>
      manualMode && chosenArticles?.length >= 3
        ? chosenArticles
        : relatedArticles,
    [manualMode, chosenArticles, relatedArticles]
  )

  const sectionRef = useScrollTrigger(
    () => ({
      trigger: sectionRef.current,
      start: () => `${window.innerHeight / 4}px bottom`,
      scrub: false
    }),
    (tl, ref) => {
      const defaults = {
        ease: 'power2.inOut',
        duration: 0.8
      }
      tl.from(ref.current.querySelectorAll(`.${styles.title}, .${styles.post}`), { y: 40, opacity: 0, stagger: 0.1, ...defaults })
    }
  )

  return (
    <div className={styles.root} ref={sectionRef}>
      <Section grid noBottomMargin>
        <h2 className={styles.title}>{title}</h2>
      </Section>
      <Slider
        disabled={width < breakpoints.md}
        options={sliderOptions}
        className={styles.slider}
      >
        {posts.map((post, index) => (
          <PostTile
            key={index}
            index={index}
            className={cn(styles.post, {
              [styles.postLandscape]: hasLandscapeImage(post)
            })}
            post={post}
          />
        ))}
      </Slider>
    </div>
  )
}

const useStyles = createUseStyles({
  root: {
    marginBottom: theme.spacingPx(10)
  },
  title: {
    gridColumn: '1 / -1',
    marginBottom: theme.spacingPx(4),
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacingPx(6)
    }
  },
  slider: {
    overflow: 'hidden',
    padding: `0 ${getGridGutter()}px`,
    [theme.breakpoints.up('md')]: {
      padding: `0 ${getGridGutter('md')}px`
    }
  },
  post: {
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacingPx(6)
    },
    [theme.breakpoints.up('md')]: {
      width: span(4, 'md', getGridGutter('md') * 2),
      marginRight: getGridGutter('md')
    }
  },
  postLandscape: {
    [theme.breakpoints.up('md')]: {
      width: span(5, 'md', getGridGutter('md') * 2),
      marginRight: getGridGutter('md')
    }
  }
})

export default JournalRelatedArticles
